import * as styles from "./StickyHeader.css";

import { useAtomValue } from "jotai";
import { useEffect } from "react";

import { useAddressBookActions } from "../../hooks/useAddressBookActions";
import { selectedCategoryAtom, shouldAnimateStickyAtom } from "../../stores";
import { ListSection } from "./ListSection";

export function StickyHeader({ letter }: { letter: string | null }) {
  const { updateStickyLetter } = useAddressBookActions();

  const selectedCategory = useAtomValue(selectedCategoryAtom);

  const shouldAnimate = useAtomValue(shouldAnimateStickyAtom);

  const isCurrentSectionLetter = !!letter;

  useEffect(() => {
    updateStickyLetter({
      letter: letter,
      categoryKey: selectedCategory?.key ?? null,
    });
  }, [letter, selectedCategory, updateStickyLetter]);

  return (
    <div className={styles.stickyHeader}>
      {isCurrentSectionLetter && (
        <div
          key={letter}
          className={shouldAnimate ? styles.stickyHeaderContent : undefined}
        >
          <ListSection letter={letter} />
        </div>
      )}
    </div>
  );
}
